module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAnUlEQVQ4T2NkoBAwUqifYTgbcFWG1ZyFmXEiKIz+/P2fr/3k90ls4YU1DG7LsWn9ZWC4iqyBmYFBW/XRr2vohmA14IYc2w4GBgZ3NMU7NR798iDKgJvybCf+/2cwR1bMyMhwUv3hLwuiDLghxxbKwMCwCk1xmMajX6uJMgCk6KYcW8V/BoYoEJuRgWGZ+qNfHUQHIimpczinRGLDAQA0HCURi2lDogAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map_point.png
// module id = +xTu
// module chunks = 5